import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {StorageKeys} from '@app/core/constants/storage-keys';
import {LocalStorageService} from '@app/core/services/local-storage.service';
import {selectCustomerRole} from '@app/shared/state/header/header.selector';
import {environment} from '@environments/environment';
import {Store} from '@ngrx/store';
import {map, withLatestFrom} from 'rxjs/operators';

export const managerGuard: CanActivateFn = () => {
  const managerRoleId = Number(environment.managerRoleId);
  const store = inject(Store);
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);

  const userRole$ = store.select(selectCustomerRole);

  return userRole$.pipe(
    withLatestFrom(userRole$),
    map(([userRole]) => {
      const storedUserRole = localStorageService.getItem(StorageKeys.selectedUserRole);

      const redirectUrl = window.location.pathname;

      const isManager = (userRole && Number(userRole) === managerRoleId) || storedUserRole === managerRoleId;

      if (isManager) {
        return true;
      } else if (redirectUrl === '/auth/institution-settings') {
        router.navigate(['/auth/profile']);
        return false;
      } else {
        router.navigate(['/my-orders']);
        return false;
      }
    })
  );
};
